import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import useIsInModal from "../Hooks/useIsInModal";
const SecondaryNavLayout = (props) => {
    React.useLayoutEffect(() => {
        // @ts-expect-error - TS2339 - Property '_aviso_fit_to_parent_initialize' does not exist on type 'Window & typeof globalThis'.
        window._aviso_fit_to_parent_initialize();
    }, []);
    const isInModal = useIsInModal();
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: (props.dontFix ? "" : "fit-to-parent-parent") + " w-100", children: _jsx("div", { className: "navbar-secondarynav flex-nowrap " +
                        (props.dontFix ? "" : "fixed fit-to-parent-child ") +
                        (props.className || ""), role: "navigation", style: { top: isInModal ? 0 : undefined }, children: props.nav }) }), !(props.dontFix || props.dontAddSpacer) && (_jsx("div", { className: classNames({
                    "secondary-nav-height": props.navOffset == null,
                    "mb-3": props.addSpaceBeforeContent,
                }), style: {
                    height: props.navOffset != null ? props.navOffset : undefined,
                } })), props.children] }));
};
export default SecondaryNavLayout;
